import type { BrandConfig } from '../branding.types';

/**
 * Example client brand configuration
 * This demonstrates how to set up a white-label brand
 */
export const exampleClientBrand: BrandConfig = {
  id: 'example-client',
  name: 'ExampleCo',
  displayName: 'ExampleCo Platform',
  tagline: 'Your Industry Intelligence Partner',
  
  assets: {
    logo: {
      light: '/brands/example-client/logo.png',
      dark: '/brands/example-client/logo_dark.png',
      favicon: '/brands/example-client/favicon.ico',
    },
  },
  
  theme: {
    // Example: Orange theme
    colorPrimary: '#FF6600',
    colorPrimaryBg: '#FFF5F0',
    colorPrimaryBgHover: '#FFE8D9',
    colorPrimaryBorder: '#FFCC99',
    colorPrimaryBorderHover: '#FFB366',
    colorPrimaryHover: '#FF8533',
    colorPrimaryActive: '#CC5200',
    colorPrimaryTextHover: '#FF8533',
    colorPrimaryText: '#FF6600',
    colorPrimaryTextActive: '#CC5200',
    
    colorLink: '#FF6600',
    colorLinkHover: '#FF8533',
    colorLinkActive: '#CC5200',
    colorInfo: '#FF6600',
  },
  
  metadata: {
    title: 'ExampleCo Platform',
    titleTemplate: '%s - ExampleCo',
    description: 'Industry intelligence and compliance platform powered by AI',
    keywords: ['industry intelligence', 'compliance', 'automation'],
  },
  
  text: {
    welcomeMessage: 'Welcome to ExampleCo Platform',
    loginTitle: 'Sign in to ExampleCo',
    loginSubtitle: 'Your Industry Intelligence Partner',
    supportEmail: 'support@example.com',
    billingEmail: 'billing@example.com',
  },
  
  features: {
    showLogo: true,
    showTagline: false,
    customLoginPage: false,
  },
};

/**
 * Another example brand with purple theme
 */
export const purpleBrand: BrandConfig = {
  id: 'purple-brand',
  name: 'Purple',
  displayName: 'Purple Platform',
  
  assets: {
    logo: {
      light: '/brands/purple/logo.png',
      dark: '/brands/purple/logo_dark.png',
      favicon: '/brands/purple/favicon.ico',
    },
  },
  
  theme: {
    colorPrimary: '#8A2BE2',
    colorPrimaryBg: '#F5E6FF',
    colorPrimaryBgHover: '#E6CCFF',
    colorPrimaryBorder: '#D1A3FF',
    colorPrimaryBorderHover: '#B366FF',
    colorPrimaryHover: '#9A3CF2',
    colorPrimaryActive: '#6A1CB2',
    colorLink: '#8A2BE2',
    colorInfo: '#8A2BE2',
  },
  
  metadata: {
    title: 'Purple Platform',
    titleTemplate: '%s | Purple',
    description: 'Advanced analytics platform',
  },
};